import { graphql } from '~publish/graphql'

/** What an unread-Notes indicator reads: the viewer's unread Note count. */
export const PostUnreadNoteCount = graphql(/* GraphQL */ `
  fragment PostUnreadNoteCount on Post @_unmask {
    id
    collaborationNotesSummary {
      unreadNoteCount
    }
  }
`)
